import styled, {css} from 'styled-components';
export const Container = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 2.5rem;
`

export const Header = styled.div`
    position: relative;
    z-index: 9;
    display: flex;
    width: 100%;
    height: 2.5rem;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #dee2e6;
    padding-left: 0.5rem;
    background-color: #ffffff;
    cursor: pointer;
    
    ${({disable}) => disable &&     
       css`        
        pointer-events: none;
        opacity: 0.6;
       `
    };
    
    input{
        outline: none;
        border: none;
        width: 100%;
        pointer-events: none;
        color: #495057;
    }

    span{
        display: flex;
        width: 2.5rem;
        height: 2rem;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
`

export const Content = styled.div`
    position: absolute;
    z-index: 9;
    display: ${({isOpen}) => isOpen ?'flex':'none'};
    top: 2.4rem;
    left: 0;
    width: 100%;
    height: auto;
    padding: 0.5rem 0;

    background: #ffffff;
    color: #495057;
    border: 0 none;
    border-radius: 4px;
    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%);

    ul{
        z-index: 999;
        width: 100%;
        height: 100%;
        max-height:10rem;
        overflow: auto;
        background: #ffffff;

        .search___{
            padding: 0 0.5rem 0 0.5rem;
            margin-bottom: 0.5rem;
        }

        &::-webkit-scrollbar{
            width: 5px;
            height: 5px;
        }

        &::-webkit-scrollbar-thumb{
            background-color: rgb(0, 0, 0,0.2);
        }
        
    }

    li{
        margin: 0;
        padding: 0.5rem 1rem;
        border: 0 none;
        color: #495057;
        background: #ffffff;
        transition: box-shadow 0.2s;
        border-radius: 0;
        cursor: pointer;

        &:hover{
            color: #495057;
            background: #e9ecef;
        }
    }

`